import React, { Suspense } from "react";
import { Box, GDSStyleObject } from "@leagueplatform/genesis-core";
import { LoadingIndicator } from "@leagueplatform/web-common-components";
import { useScrollTopOnLocationChange } from "@leagueplatform/web-common";
import {
  AppHeader,
  HEADER_NAV_BAR_DEFAULT_HEIGHT,
} from "components/app-header/app-header.component";
import { AppFooter } from "components/app-footer/app-footer.component";
import { QueryParamModal } from "components/query-param-modal/query-param-modal.component";

type BasePageProps = {
  children: React.ReactNode;
  css?: GDSStyleObject;
  isPrivatePage?: boolean;
};

export const BasePage = ({
  children,
  isPrivatePage = true,
  css,
}: BasePageProps) => {
  useScrollTopOnLocationChange();

  const mainContentMinHeight = isPrivatePage
    ? `calc(100dvh - ${HEADER_NAV_BAR_DEFAULT_HEIGHT}px)`
    : "100dvh";

  return (
    <>
      {isPrivatePage && <AppHeader />}
      <Box
        as="main"
        id="main-content"
        css={{
          position: "relative",
          flex: "1",
          minHeight: mainContentMinHeight,
          overflowX: "hidden",
          paddingBlockEnd: "$three",
          ...css,
        }}
      >
        <Suspense fallback={<LoadingIndicator />}>{children}</Suspense>
      </Box>
      <AppFooter />
      {isPrivatePage && <QueryParamModal />}
    </>
  );
};
